import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import BackendService from '../services/backendService';
import { Template } from '../services/TemplateService/Template.type';
import { useMetrics } from './useMetrics';
import { templatesCacheKey } from './useTemplates';

export const deletedTemplatesCacheKey = 'deletedTemplates';
function useDeletedTemplates() {
  const metrics = useMetrics();
  const client = useQueryClient();
  const { data: templates, isFetching: isFetchingTemplates } = useQuery(
    [deletedTemplatesCacheKey],
    async _ => {
      const templates = await BackendService.instance.template.listDeletedTemplates();
      return templates;
    },
    { staleTime: 1000 * 60 * 5 },
  );
  const { mutate: restoreTemplate, isLoading: isRestoringTemplate } = useMutation(
    ({
      templateId,
    }: {
      templateId: string;
      onSuccessFunction?: (data: Template) => void | undefined;
    }) => {
      metrics.logEvent('Template.Restore', { id: templateId });
      return BackendService.instance.template.restoreTemplate(templateId);
    },
    {
      onSettled: () => {
        client.invalidateQueries([deletedTemplatesCacheKey]);
        client.invalidateQueries([templatesCacheKey]);
      },
      onSuccess: (data, { onSuccessFunction }) => {
        if (onSuccessFunction) {
          onSuccessFunction(data);
        }
      },
    },
  );

  return {
    templates,
    restoreTemplate,
    isRestoringTemplate,
    isFetchingTemplates,
  };
}
export default useDeletedTemplates;
